module.exports = __webpack_public_path__ + "img/header.37c3ea6b.png";